import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import {
  inverterMappingArrayAction,
  projectDetailAction,
  scbSmbMappingArrayAction,
} from "../../actions/energyAction";
import {
  clear_errors,
  project_detail_reset,
} from "../../constants/dataConstants";

import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
  Paper,
  Breadcrumbs,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon ,
  ChevronRight as ChevronRightIcon ,
  Public as PublicIcon,
  People as PeopleIcon,
  Home as HomeIcon,
  BarChart as BarChartIcon,
  Storage as StorageIcon,
  ElectricBolt as ElectricBoltIcon,
  Memory as MemoryIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  Menu as MenuIcon,
  ChevronRight,
  Warning,
  Cable,
} from "@mui/icons-material";
import logo from "../../fonts and images/newLogo.jpg";

import { useNavigate } from "react-router-dom";
import PageURL from "../../constants/PageURL";
import { userLogout } from "../../actions/userActions";
import { toast } from "react-toastify";
import FetchProjectDetailLoader from "../../components/Loaders/FetchProjectDetailLoader";

const initialOpenSubHeader = {
  projectDetail: false,
  Diagonistic: false,
  inverterEfficiency: false,
  inverterDeviation: false,
  checkedData: false,
  Prescritive: false,
  string_smb: false,
  correctiveAction: false,
};

const styles2 = {
  mainContent: {
    flexGrow: 1,
    p: 3,
    width: { md: `calc(100% - 250px)` },
    maxWidth: 1200,
    margin: "0 auto",
  },
  selectionCard: {
    p: 3,
    borderRadius: 2,
    background: "linear-gradient(to bottom right, #f5f7fa 0%, #ffffff 100%)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    mb: 2,
    gap: 2,
  },
  headerIcon: {
    fontSize: "2.5rem",
    color: "primary.main",
  },
  titleContainer: {
    flex: 1,
  },
  projectTitle: {
    fontWeight: 700,
    letterSpacing: "-0.5px",
    lineHeight: 1.2,
  },
  projectSubtitle: {
    color: "text.secondary",
    display: "flex",
    alignItems: "center",
    gap: 1,
    "&::before": {
      content: '""',
      display: "inline-block",
      width: 4,
      height: 4,
      borderRadius: "50%",
      backgroundColor: "text.secondary",
    },
  },
};

// CSS styles
const styles = {
  listItem: {
    "& .MuiListItemButton-root": {
      paddingTop: "4px",
      paddingBottom: "4px",
    },
    "& .MuiListItemIcon-root": {
      minWidth: "32px", // Reduced from default 36px
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.775rem", // Reduced from default 1rem
    },
    "& .MuiSvgIcon-root": {
      fontSize: "0.775rem", // Adjust icon size
    },
  },
  nestedItem: {
    "& .MuiListItemButton-root": {
      paddingLeft: "32px", // Indent nested items
      paddingTop: "2px",
      paddingBottom: "2px",
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.775rem", // Slightly smaller for nested items
    }
  },
  listGap: {
    marginBottom: "4px", // Add gap between main list items
  },
  drawer: {
    width: 230,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
      width: 230,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
    },
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "10px 16px",
    justifyContent: "space-between",
    background: "#203864",
    color: "white",
    border: "none",
    height: "70px",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  },
  content: {
    flexGrow: 1,
    padding: "24px",
    transition: "margin 0.2s ease",
  },
  contentShift: {
    marginLeft: 250,
  },
  nestedItem: {
    paddingLeft: "20px",

  },
  nestedItemLevel2: {
    paddingLeft: "45px",

  },
  nestedItemLevel3: {
    paddingLeft: "55px",
  },
  nestedItemLevel4: {
    paddingLeft: "65px",
  },
  nestedItemLevel5: {
    paddingLeft: "75px",
  },
  menuButton: {
    position: "fixed",
    top: "10px",
    left: "20px",
    zIndex: 1200,
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    "&:hover": {
      backgroundColor: "#203864",
    }
  },
  logoutContainer: {
    marginTop: "auto",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    background: "#203864",
    color: "white",
  },
  mainContent: {
    padding: "20px",
  },
  selectionCard: {
    padding: "16px",
    marginBottom: "20px",
  },
  selectionItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  selectionLabel: {
    fontWeight: "bold",
    marginRight: "8px",
    minWidth: "120px",
  },
  selectionValue: {
    color: "rgba(0, 0, 0, 0.7)",
  },
  ...styles2,
};

// Create a context to share selected items across components
const ProjectContext = React.createContext({
  selectedCountry: "",
  selectedPartner: "",
  selectedProject: "",
  selectedDetails: "",
  setSelectedCountry: (country) => {},
  setSelectedPartner: (partner) => {},
  setSelectedProject: (project) => {},
  setSelectedDetails: (details) => {},
});

export function ProjectSidebar(props) {
  const {
    openSidebar,
    setOpenSidebar,
    selectedValue,
    setSelectedValue,
    scbsmbDetail,
    setscbsmbDetail,
    selectedLebel,
    databaseStr,
    open,
    setOpen,
  } = props;

  const { user = {} } = useSelector((state) => state.user);
  const {
    projectDetail,
    availableProject,
    loading: loading2,
    scbSmbMappingArray,
    scbSmbMappingLoader,
    inverterMappingArray,
    inverterMappingLoader,
  } = useSelector((state) => state.projectDetail);
  const [checkedData, setCheckedData] = React.useState(initialOpenSubHeader);

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLogout, error } = useSelector((state) => state.user);

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  // Selected items state
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedPartner, setSelectedPartner] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedDetails, setSelectedDetails] = useState("");

  const [openMenus, setOpenMenus] = useState({
    projectDetails: true,
    country: false,
    partners: false,
    projectName: false,
    projectDetailsDropdown: false,
    overviewDetails: false,
    diagnosticModel: false,
    inverterEfficiency: false,
    inverterDeviation: false,
    scbString: false,
  });

  const serachParams = new URLSearchParams(location.search);

  const onclickHandler = (name, trueValue1, trueValue2, trueValue3) => {
    let checked = { ...checkedData };
    for (let key in checked) {
      if (key === name) {
        checked[key] = !checked[key];
      } else {
        checked[key] = false;
      }
    }
    if (trueValue1) {
      checked[trueValue1] = true;
    }
    if (trueValue2) {
      checked[trueValue2] = true;
    }
    if (trueValue3) {
      checked[trueValue3] = true;
    }

    setCheckedData(checked);
  };

  const toggleMenu = (menuType) => {
    // const obj={}
    // if(menuType==="country")obj["partners"]=true
    // else if(menuType==="partners")obj["projectName"]=true
    // else if(menuType==="projectName")obj["projectDetailsDropdown"]=true
    setOpenMenus((prev) => ({
      ...prev,
      [menuType]: !prev[menuType],
    }));
  };

  const handleSelectAllInverters = ({
    block,
    subBlock = null,
    inverter = null,
    route = false,
  }) => {
    setSelectedValue({
      ...selectedValue,
      projectDetail: "All Inverters",
    });

    setscbsmbDetail({
      block: block?.name,
      sub_block: subBlock?.name || null,
      inverter: inverter?.name || null,
      inverterType: subBlock?.type || block?.type || null,
      stack: null,
      scbsmb: null,
      scbsmbType: null,
    });
    if (route) {
      if (location.pathname !== PageURL.INDIA_INVERTER_DEVIATION) {
        navigate(
          `${PageURL.INDIA_INVERTER_DEVIATION}?${serachParams.toString()}`
        );
      }
    } else {
      if (location.pathname !== PageURL.INDIA_INVERTER_EFFICIENCY) {
        navigate(
          `${PageURL.INDIA_INVERTER_EFFICIENCY}?${serachParams.toString()}`
        );
      }
    }
  };

  const handleSelectInverter = (block, subBlock = null, inverter) => {
    setSelectedValue({
      ...selectedValue,
      projectDetail: inverter,
    });

    setscbsmbDetail({
      block: block?.name,
      sub_block: subBlock?.name || null,
      inverter: inverter,
      inverterType: subBlock?.type || block?.type || null,
      stack: null,
      scbsmb: null,
      scbsmbType: null,
    });

    if (location.pathname !== PageURL.INDIA_INVERTER_EFFICIENCY) {
      navigate(
        `${PageURL.INDIA_INVERTER_EFFICIENCY}?${serachParams.toString()}`
      );
    }
  };

  const handleSelectStack = (block, subBlock, inverter, stack) => {
    setSelectedValue({
      ...selectedValue,
      projectDetail: stack,
    });

    setscbsmbDetail({
      block: block?.name,
      sub_block: subBlock?.name || null,
      inverter: inverter?.name || null,
      stack: stack,
      inverterType: inverter?.type || subBlock?.type || block?.type || null,
    });

    if (location.pathname !== PageURL.INDIA_INVERTER_EFFICIENCY) {
      navigate(
        `${PageURL.INDIA_INVERTER_EFFICIENCY}?${serachParams.toString()}`
      );
    }
  };

  const stringType = projectDetail?.plantDetail?.string || "STRING";

  const handleSelectAllStrings = (
    block,
    subBlock = null,
    inverter = null,
    stack = null
  ) => {
    setSelectedValue({
      ...selectedValue,
      projectDetail: `All ${stringType} Deviation`,
    });

    setscbsmbDetail({
      block: block?.name,
      sub_block: subBlock?.name || null,
      inverter: inverter?.name || null,
      inverterType: inverter?.inverterType || subBlock?.inverterType || null,
      stack: stack?.name || null,
      scbsmb: null,
      scbsmbType: stringType,
    });

    if (location.pathname !== PageURL.SCBSMB_LOSS) {
      navigate(`${PageURL.SCBSMB_LOSS}?${serachParams.toString()}`);
    }
  };

  const handleSelectHeatMap = (
    block,
    subBlock = null,
    inverter = null,
    stack = null
  ) => {
    setSelectedValue({
      ...selectedValue,
      projectDetail: "HeatMap",
    });

    setscbsmbDetail({
      block: block?.name,
      sub_block: subBlock?.name || null,
      inverter: inverter?.name || null,
      inverterType: inverter?.inverterType || subBlock?.inverterType || null,
      stack: stack?.name || null,
      scbsmb: null,
      heatmap: true,
      scbsmbType: stringType,
    });

    if (location.pathname !== PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM) {
      navigate(
        `${PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM}?${serachParams.toString()}`
      );
    }
  };

  const handleSelectScbSmb = (
    block,
    subBlock = null,
    inverter = null,
    stack = null,
    scbSmb
  ) => {
    setSelectedValue({
      ...selectedValue,
      projectDetail: scbSmb,
    });

    setscbsmbDetail({
      block: block?.name,
      sub_block: subBlock?.name || null,
      inverter: inverter?.name || null,
      inverterType: inverter?.inverterType || subBlock?.inverterType || null,
      stack: stack?.name || null,
      scbsmb: scbSmb,
      scbsmbType: stringType,
    });

    if (location.pathname !== PageURL.SCBSMB_LOSS) {
      navigate(`${PageURL.SCBSMB_LOSS}?${serachParams.toString()}`);
    }
  };

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setOpen(!open);
    }
  };

  window.onresize = () => {
    if (openSidebar && window.innerWidth >= 950) {
      setOpenSidebar(false);
    }
  };
  useEffect(() => {
    if (databaseStr) {
      dispatch(projectDetailAction(user?.userName, databaseStr));
    }
  }, [databaseStr]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: clear_errors });
      dispatch({ type: "USER_LOGOUT" });
    }
    if (isLogout) {
      toast.success("User Logged out sucessfully!");
      dispatch({ type: "USER_LOGOUT" });
      navigate(PageURL.BASE);
    }
  }, [isLogout, error]);

  useEffect(() => {
    if (availableProject) {
      dispatch({ type: project_detail_reset });
      if (location.pathname !== PageURL.PROJECT_DETAILS) {
        navigate(`${PageURL.PROJECT_DETAILS}?${serachParams.toString()}`);
      }
      setOpenMenus({
        ...openMenus,
        overviewDetails: false,
        diagnosticModel: false,
        inverterEfficiency: false,
        inverterDeviation: false,
        scbString: false,
      });
    }
    if (!projectDetail) {
      setCheckedData(initialOpenSubHeader);
    }
  }, [projectDetail, navigate, availableProject]);

  // Initialize all menu states based on inverterMappingArray
  useEffect(() => {
    if (inverterMappingArray?.length > 0) {
      const initialState = {};

      inverterMappingArray.forEach((block) => {
        // Block level menus
        initialState[`${block.name}Efficiency`] = false;
        initialState[`${block.name}Deviation`] = false;

        if (block.subBlocks) {
          block.subBlocks.forEach((subBlock) => {
            // Sub-block level menus
            initialState[`${block.name}${subBlock.name}Efficiency`] = false;
            initialState[`${block.name}${subBlock.name}Deviation`] = false;

            if (subBlock.inverters?.[0]?.stacks) {
              subBlock.inverters.forEach((inverter) => {
                // Inverter level menus
                initialState[
                  `${block.name}${subBlock.name}${inverter.name}Efficiency`
                ] = false;
                initialState[
                  `${block.name}${subBlock.name}${inverter.name}Deviation`
                ] = false;
              });
            }
          });
        } else if (block.inverters?.[0]?.stacks) {
          block.inverters.forEach((inverter) => {
            // Inverter level menus (without sub-blocks)
            initialState[`${block.name}${inverter.name}Efficiency`] = false;
            initialState[`${block.name}${inverter.name}Deviation`] = false;
          });
        }
      });

      setOpenMenus((prev) => ({ ...prev, ...initialState }));
    }
  }, [inverterMappingArray]);

  // Initialize all menu states based on scbSmbMappingArray
  useEffect(() => {
    if (scbSmbMappingArray?.length > 0) {
      const initialState = {};

      scbSmbMappingArray.forEach((element) => {
        // Block level
        initialState[`block-${element.name}`] = false;

        // Handle subBlocks first
        element.subBlocks?.forEach((subBlock) => {
          // Sub-block level
          initialState[`subBlock-${element.name}-${subBlock.name}`] = false;

          subBlock.inverters?.forEach((inverter) => {
            if (inverter?.stacks) {
              // Inverter with stacks level
              initialState[
                `inverter-${element.name}-${subBlock.name}-${inverter.name}`
              ] = false;

              inverter?.stacks?.forEach((stack) => {
                // Stack level
                initialState[
                  `stack-${element.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                ] = false;
              });
            } else {
              // Inverter without stacks level
              initialState[
                `inverter-${element.name}-${subBlock.name}-${inverter.name}`
              ] = false;
            }
          });
        });

        // If no subBlocks, handle inverters directly
        if (!element.subBlocks) {
          element.inverters?.forEach((inverter) => {
            if (inverter?.stacks) {
              // Inverter with stacks level
              initialState[`inverter-${element.name}-${inverter.name}`] = false;

              inverter?.stacks?.forEach((stack) => {
                // Stack level
                initialState[
                  `stack-${element.name}-${inverter.name}-${stack.name}`
                ] = false;
              });
            } else {
              // Inverter without stacks level
              initialState[`inverter-${element.name}-${inverter.name}`] = false;
            }
          });
        }
      });

      setOpenMenus((prev) => ({ ...prev, ...initialState }));
    }
  }, [scbSmbMappingArray]);

  const drawer = (
    <>
      <Box sx={styles.drawerHeader}>
        <Box onClick={() => navigate(PageURL.COUNTRYDEFAULT)} sx={styles.logo}>
          {/* <ElectricBoltIcon color="primary" />
          <Typography variant="h6" component="div">
            SolarMonitor
          </Typography> */}
          <img src={logo} alt="GreenEnco-Logo" height={50} />
        </Box>
        {isMobile && (
          <IconButton onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
        )}
      </Box>
      {/* <Divider sx={{background:"rgb(233, 182, 116)"}} /> */}
      <Box
        sx={{
          overflow: "auto",
          flexGrow: 1,
          background: "#203864",
          color: "white",
          padding: 0,
          paddingTop: "1rem",

          // Scrollbar for WebKit browsers
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#1a2d4f",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#4a90e2",
            borderRadius: "4px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#6aaaf5",
          },
          // Firefox support
          scrollbarWidth: "thin",
          scrollbarColor: "#4a90e2 #1a2d4f",
        }}
      >
        <List component="nav" disablePadding>
          {/* Project Details with nested dropdowns */}

          {/* Country Dropdown */}
          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleMenu("country")}>
              <ListItemIcon>
                <PublicIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />{" "}
                {/* Adjust icon size */}
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                primary="Country"
              />
              {openMenus.country ? (
                <ExpandLessIcon sx={{ fontSize: "0.775rem" }}  />
              ) : (
                <ChevronRightIcon sx={{ fontSize: "0.775rem" }}  />
              )}
            </ListItemButton>
          </ListItem>
          <Collapse in={openMenus.country} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {user?.projects?.country?.map((country) => (
                <ListItem key={country} disablePadding sx={styles.nestedItem}>
                  <ListItemButton
                    onClick={() => {
                      setSelectedValue({
                        ...selectedValue,
                        country: country,
                        partnerName: "",
                        projectName: "",
                        projectDetail: "",
                      });

                      setCheckedData({
                        ...checkedData,
                        projectDetail: false,
                        Diagonistic: false,
                        Efficiency: false,
                        checkedData: false,
                        Prescritive: false,
                        string_smb: false,
                        correctiveAction: false,
                      });
                      toggleMenu("country");
                      toggleMenu("partners");
                    }}
                    selected={selectedValue?.country === country}
                  >
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary={`${country} ${
                        user?.projects?.partnersName?.find(
                          (e) => e.country === country
                        )?.partnerName?.length
                          ? ` - [ ${
                              user?.projects?.partnersName?.find(
                                (e) => e.country === country
                              )?.partnerName?.length
                            } ]`
                          : null
                      }`}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Collapse>

          {/* Partners Dropdown */}
          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleMenu("partners")}>
              <ListItemIcon>
                <PeopleIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
              </ListItemIcon>
              <ListItemText
                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                primary="Partners Name"
              />
              {openMenus.partners ? <ExpandLessIcon sx={{ fontSize: "0.775rem" }} /> : <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />}
            </ListItemButton>
          </ListItem>
          <Collapse in={openMenus.partners} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {user?.projects.partnersName
                ?.find((e) => e.country === selectedValue?.country)
                ?.partnerName?.map((partner) => (
                  <ListItem key={partner} disablePadding sx={styles.nestedItem}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedValue({
                          ...selectedValue,
                          partnerName: partner,
                          projectName: "",
                          projectDetail: "",
                        });
                        setCheckedData({
                          ...checkedData,
                          projectDetail: false,
                          Diagonistic: false,
                          Efficiency: false,
                          checkedData: false,
                          Prescritive: false,
                          string_smb: false,
                          correctiveAction: false,
                        });
                        toggleMenu("partners");
                        toggleMenu("projectName");
                      }}
                      selected={selectedValue?.partnerName === partner}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary={partner}
                      />
                    </ListItemButton>
                  </ListItem>
                )) || (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary={"Select A Country"}
                    />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>

          {/* Project Name Dropdown */}
          <ListItem disablePadding>
            <ListItemButton onClick={() => toggleMenu("projectName")}>
              <ListItemIcon>
                <HomeIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
              </ListItemIcon>
              <ListItemText
                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                primary="Project Name"
              />
              {openMenus.projectName ? (
                <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
              ) : (
                <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
              )}
            </ListItemButton>
          </ListItem>
          <Collapse in={openMenus.projectName} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {user?.projects?.projectName
                ?.find(
                  (e) =>
                    e.country === selectedValue.country &&
                    e.partnerName === selectedValue.partnerName
                )
                ?.projectName?.map((project) => (
                  <ListItem
                    key={project?.name}
                    disablePadding
                    sx={styles.nestedItem}
                  >
                    <ListItemButton
                      onClick={() => {
                        setSelectedValue({
                          ...selectedValue,
                          projectName: project?.name,
                          projectDetail: "",
                        });
                        setCheckedData({
                          ...checkedData,
                          projectDetail: false,
                          Diagonistic: false,
                          Efficiency: false,
                          checkedData: false,
                          Prescritive: false,
                          string_smb: false,
                          correctiveAction: false,
                        });
                        toggleMenu("projectName");
                        toggleMenu("projectDetailsDropdown");
                      }}
                      selected={selectedValue?.projectName === project?.name}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary={`${project?.name} (${project?.capacity})`}
                      />
                    </ListItemButton>
                  </ListItem>
                )) || (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary={"Select A Partner"}
                    />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>

          {/* Project Details Dropdown */}
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => toggleMenu("projectDetailsDropdown")}
            >
              <ListItemIcon>
                <BarChartIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
              </ListItemIcon>
              <ListItemText
                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                primary="Project Details"
              />
              {openMenus.projectDetailsDropdown ? (
                <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
              ) : (
                <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
              )}
            </ListItemButton>
          </ListItem>
          <Collapse
            in={openMenus.projectDetailsDropdown}
            timeout="auto"
            unmountOnExit
          >
            {loading2 ? (
              <ListItem disablePadding sx={styles.nestedItem}>
                <ListItemButton onClick={() => toggleMenu("overviewDetails")}>
                  <ListItemText
                                    primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                    primary={"Fetching Project Details"}
                  />
                  <CircularProgress size={20} />
                  {/* <FetchProjectDetailLoader title={"Fetch Project Details"}/> */}
                </ListItemButton>
              </ListItem>
            ) : !projectDetail ? (
              <ListItem disablePadding sx={styles.nestedItem}>
                <ListItemButton onClick={() => toggleMenu("overviewDetails")}>
                  <ListItemText
                                    primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                    primary={"Project Not Found"}
                  />
                </ListItemButton>
              </ListItem>
            ) : null}
            <List component="div" disablePadding>
              {/* Overview Details */}
              {projectDetail && (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton onClick={() => toggleMenu("overviewDetails")}>
                    <ListItemIcon>
                      <DashboardIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
                    </ListItemIcon>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary="Overview Details"
                    />
                    {openMenus.overviewDetails ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              <Collapse
                in={openMenus.overviewDetails}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  <ListItem disablePadding sx={styles.nestedItemLevel2}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedDetails("Project Overview");
                        navigate(
                          `${
                            PageURL.INDIA_PROJ_OVERVIEW
                          }?${serachParams.toString()}`
                        );
                      }}
                      selected={selectedDetails === "Project Overview"}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary="Project Overview"
                      />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding sx={styles.nestedItemLevel2}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedDetails("Generation Summary");
                        navigate(
                          `${
                            PageURL.INDIA_GEN_SUMMARY
                          }?${serachParams.toString()}`
                        );
                      }}
                      selected={selectedDetails === "Generation Summary"}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary="Generation Summary"
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              </Collapse>

              {/* Diagnostic Model */}
              {projectDetail && (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton onClick={() => toggleMenu("diagnosticModel")}>
                    <ListItemIcon>
                      <StorageIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
                    </ListItemIcon>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary="Diagnostic Model"
                    />
                    {openMenus.diagnosticModel ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              <Collapse
                in={openMenus.diagnosticModel}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  <ListItem disablePadding sx={styles.nestedItemLevel2}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedDetails("Detailed Summary");
                        navigate(
                          `${
                            PageURL.INDIA_DIAGONISTIC_DETAILED
                          }?${serachParams.toString()}`
                        );
                      }}
                      selected={selectedDetails === "Detailed Summary"}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary="Detailed Summary"
                      />
                    </ListItemButton>
                  </ListItem>
                  {projectDetail?.plantDataAvailability
                    ?.showLossFlowDiagram && (
                    <ListItem disablePadding sx={styles.nestedItemLevel2}>
                      <ListItemButton
                        onClick={() => {
                          setSelectedDetails("Loss Flow Diagram");
                          navigate(
                            `${
                              PageURL.INDIA_LOSS_FLOW
                            }?${serachParams.toString()}`
                          );
                        }}
                        selected={selectedDetails === "Loss Flow Diagram"}
                      >
                        <ListItemText
                                          primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                          primary="Loss Flow Diagram"
                        />
                      </ListItemButton>
                    </ListItem>
                  )}
                </List>
              </Collapse>
              {projectDetail && (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton
                    onClick={() => {
                      if (!inverterMappingArray) {
                        dispatch(inverterMappingArrayAction(databaseStr));
                      }
                      toggleMenu("inverterEfficiency");
                    }}
                  >
                    <ListItemIcon>
                      <ElectricBoltIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
                    </ListItemIcon>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary="Inverter Efficiency"
                    />
                    {openMenus.inverterEfficiency ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              <Collapse
                in={openMenus.inverterEfficiency}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {inverterMappingLoader ? (
                    <ListItem sx={{ justifyContent: "center" }}>
                      <FetchProjectDetailLoader width="25px" />
                    </ListItem>
                  ) : !inverterMappingArray ? (
                    <ListItem sx={styles.nestedItemLevel3}>
                      Inverter Data Not Found
                    </ListItem>
                  ) : inverterMappingArray?.length === 0 ? (
                    <ListItem sx={styles.nestedItemLevel3}>
                      Inverter Data Not Available
                    </ListItem>
                  ) : (
                    <>
                      <ListItem
                        disablePadding
                        sx={styles.nestedItemLevel2}
                        selected={
                          selectedValue.projectDetail === "All Inverters"
                        }
                      >
                        <ListItemButton
                          onClick={() => handleSelectAllInverters({})}
                        >
                          <ListItemText
                                            primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                            primary="All Inverters"
                          />
                        </ListItemButton>
                      </ListItem>

                      {inverterMappingArray.map((block) => (
                        <React.Fragment key={block.name}>
                          <ListItem disablePadding sx={styles.nestedItemLevel2}>
                            <ListItemButton
                              onClick={() =>
                                toggleMenu(`${block.name}Efficiency`)
                              }
                            >
                              <ListItemText
                                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                primary={block.name}
                              />
                              {openMenus[`${block.name}Efficiency`] ? (
                                <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                              ) : (
                                <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                              )}
                            </ListItemButton>
                          </ListItem>

                          <Collapse
                            in={openMenus[`${block.name}Efficiency`]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {block.subBlocks ? (
                                block.subBlocks.map((subBlock) => (
                                  <React.Fragment
                                    key={`${block.name}-${subBlock.name}`}
                                  >
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel3}
                                    >
                                      <ListItemButton
                                        onClick={() =>
                                          toggleMenu(
                                            `${block.name}${subBlock.name}Efficiency`
                                          )
                                        }
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                          primary={subBlock.name}
                                        />
                                        {openMenus[
                                          `${block.name}${subBlock.name}Efficiency`
                                        ] ? (
                                          <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                        ) : (
                                          <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                        )}
                                      </ListItemButton>
                                    </ListItem>

                                    <Collapse
                                      in={
                                        openMenus[
                                          `${block.name}${subBlock.name}Efficiency`
                                        ]
                                      }
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <List component="div" disablePadding>
                                        {subBlock.inverters?.length > 1 && (
                                          <ListItem
                                            disablePadding
                                            sx={styles.nestedItemLevel3}
                                            selected={
                                              selectedValue.projectDetail ===
                                                "All Inverter" &&
                                              scbsmbDetail.block ===
                                                block.name &&
                                              scbsmbDetail.sub_block ===
                                                subBlock.name
                                            }
                                          >
                                            <ListItemButton
                                              onClick={() =>
                                                handleSelectAllInverters({
                                                  block,
                                                  subBlock,
                                                })
                                              }
                                            >
                                              <ListItemText
                                                primaryTypographyProps={{
                                                  variant: "body2",
                                                   sx: { fontSize: "0.775rem" },
                                                }}
                                                primary="All Inverters"
                                              />
                                            </ListItemButton>
                                          </ListItem>
                                        )}

                                        {subBlock.inverters.map((inverter) =>
                                          subBlock.stacks ? (
                                            <React.Fragment
                                              key={`${block.name}-${subBlock.name}-${inverter.name}`}
                                            >
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel3}
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    toggleMenu(
                                                      `${block.name}${subBlock.name}${inverter.name}Efficiency`
                                                    )
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                       sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary={inverter.name}
                                                  />
                                                  {openMenus[
                                                    `${block.name}${subBlock.name}${inverter.name}Efficiency`
                                                  ] ? (
                                                    <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                                  ) : (
                                                    <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                                  )}
                                                </ListItemButton>
                                              </ListItem>

                                              <Collapse
                                                in={
                                                  openMenus[
                                                    `${block.name}${subBlock.name}${inverter.name}Efficiency`
                                                  ]
                                                }
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <List
                                                  component="div"
                                                  disablePadding
                                                >
                                                  {inverter.stacks?.length >
                                                    1 && (
                                                    <ListItem
                                                      disablePadding
                                                      sx={
                                                        styles.nestedItemLevel3
                                                      }
                                                      selected={
                                                        selectedValue.projectDetail ===
                                                          "All Inverter" &&
                                                        scbsmbDetail.block ===
                                                          block.name &&
                                                        scbsmbDetail.sub_block ===
                                                          subBlock.name &&
                                                        scbsmbDetail.inverter ===
                                                          inverter.name
                                                      }
                                                    >
                                                      <ListItemButton
                                                        onClick={() =>
                                                          handleSelectAllInverters(
                                                            {
                                                              block,
                                                              subBlock,
                                                              inverter,
                                                            }
                                                          )
                                                        }
                                                      >
                                                        <ListItemText
                                                          primaryTypographyProps={{
                                                            variant: "body2",
                                                             sx: { fontSize: "0.775rem" },
                                                          }}
                                                          primary="All Stacks"
                                                        />
                                                      </ListItemButton>
                                                    </ListItem>
                                                  )}

                                                  {inverter.stacks.map(
                                                    (stack) => (
                                                      <ListItem
                                                        key={`${block.name}-${subBlock.name}-${inverter.name}-${stack}`}
                                                        disablePadding
                                                        sx={
                                                          styles.nestedItemLevel3
                                                        }
                                                        selected={
                                                          selectedValue.projectDetail ===
                                                            stack &&
                                                          scbsmbDetail.block ===
                                                            block.name &&
                                                          scbsmbDetail.sub_block ===
                                                            subBlock.name &&
                                                          scbsmbDetail.inverter ===
                                                            inverter.name
                                                        }
                                                      >
                                                        <ListItemButton
                                                          onClick={() =>
                                                            handleSelectStack(
                                                              block,
                                                              subBlock,
                                                              inverter,
                                                              stack
                                                            )
                                                          }
                                                        >
                                                          <ListItemText
                                                           primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                                            primary={stack}
                                                          />
                                                        </ListItemButton>
                                                      </ListItem>
                                                    )
                                                  )}
                                                </List>
                                              </Collapse>
                                            </React.Fragment>
                                          ) : (
                                            <ListItem
                                              key={`${block.name}-${subBlock.name}-${inverter}`}
                                              disablePadding
                                              sx={styles.nestedItemLevel3}
                                              selected={
                                                selectedValue.projectDetail ===
                                                  inverter &&
                                                scbsmbDetail.block ===
                                                  block.name &&
                                                scbsmbDetail.sub_block ===
                                                  subBlock.name
                                              }
                                            >
                                              <ListItemButton
                                                onClick={() =>
                                                  handleSelectInverter(
                                                    block,
                                                    subBlock,
                                                    inverter
                                                  )
                                                }
                                              >
                                                <ListItemText
                                                  primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                                  primary={inverter}
                                                />
                                              </ListItemButton>
                                            </ListItem>
                                          )
                                        )}
                                      </List>
                                    </Collapse>
                                  </React.Fragment>
                                ))
                              ) : (
                                <>
                                  {block.inverters?.length > 1 && (
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel3}
                                      selected={
                                        selectedValue.projectDetail ===
                                          "All Inverter" &&
                                        scbsmbDetail.block === block.name
                                      }
                                    >
                                      <ListItemButton
                                        onClick={() =>
                                          handleSelectAllInverters({ block })
                                        }
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                          primary="All Inverters"
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  )}

                                  {block.inverters.map((inverter) =>
                                    block.inverters[0]?.stacks ? (
                                      <React.Fragment
                                        key={`${block.name}-${inverter.name}`}
                                      >
                                        <ListItem
                                          disablePadding
                                          sx={styles.nestedItemLevel3}
                                        >
                                          <ListItemButton
                                            onClick={() =>
                                              toggleMenu(
                                                `${block.name}${inverter.name}Efficiency`
                                              )
                                            }
                                          >
                                            <ListItemText
                                              primaryTypographyProps={{
                                                variant: "body2",
                                                                  sx: { fontSize: "0.775rem" },
                                              }}
                                              primary={inverter.name}
                                            />
                                            {openMenus[
                                              `${block.name}${inverter.name}Efficiency`
                                            ] ? (
                                              <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                            ) : (
                                              <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                            )}
                                          </ListItemButton>
                                        </ListItem>

                                        <Collapse
                                          in={
                                            openMenus[
                                              `${block.name}${inverter.name}Efficiency`
                                            ]
                                          }
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          <List component="div" disablePadding>
                                            {inverter.stacks?.length > 1 && (
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel3}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                    "All Inverter" &&
                                                  scbsmbDetail.block ===
                                                    block.name &&
                                                  scbsmbDetail.inverter ===
                                                    inverter.name
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    handleSelectAllInverters({
                                                      block,
                                                      subBlock: null,
                                                      inverter,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary="All Stacks"
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            )}

                                            {inverter.stacks.map((stack) => (
                                              <ListItem
                                                key={`${block.name}-${inverter.name}-${stack}`}
                                                disablePadding
                                                sx={styles.nestedItemLevel3}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                    stack &&
                                                  scbsmbDetail.block ===
                                                    block.name &&
                                                  scbsmbDetail.inverter ===
                                                    inverter.name
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    handleSelectStack(
                                                      block,
                                                      null,
                                                      inverter,
                                                      stack
                                                    )
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary={stack}
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            ))}
                                          </List>
                                        </Collapse>
                                      </React.Fragment>
                                    ) : (
                                      <ListItem
                                        key={`${block.name}-${inverter}`}
                                        disablePadding
                                        sx={styles.nestedItemLevel3}
                                        selected={
                                          selectedValue.projectDetail ===
                                            inverter &&
                                          scbsmbDetail.block === block.name
                                        }
                                      >
                                        <ListItemButton
                                          onClick={() =>
                                            handleSelectInverter(
                                              block,
                                              null,
                                              inverter
                                            )
                                          }
                                        >
                                          <ListItemText
                                            primaryTypographyProps={{
                                              variant: "body2",
                                                                sx: { fontSize: "0.775rem" },
                                            }}
                                            primary={inverter}
                                          />
                                        </ListItemButton>
                                      </ListItem>
                                    )
                                  )}
                                </>
                              )}
                            </List>
                          </Collapse>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </List>
              </Collapse>
              {projectDetail?.plantDataAvailability?.inverterDeviation && (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton
                    onClick={() => {
                      if (!inverterMappingArray) {
                        dispatch(inverterMappingArrayAction(databaseStr));
                      }
                      toggleMenu("inverterDeviation");
                    }}
                  >
                    <ListItemIcon>
                      <Warning fontSize="small" sx={{ fontSize: "0.875rem" }} />
                    </ListItemIcon>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary="Inverter Deviation"
                    />
                    {openMenus.inverterDeviation ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              <Collapse
                in={openMenus.inverterDeviation}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {inverterMappingLoader ? (
                    <ListItem sx={{ justifyContent: "center" }}>
                      <FetchProjectDetailLoader width="25px" />
                    </ListItem>
                  ) : !inverterMappingArray ? (
                    <ListItem sx={styles.nestedItemLevel3}>
                      Inverter Data Not Found
                    </ListItem>
                  ) : inverterMappingArray?.length === 0 ? (
                    <ListItem sx={styles.nestedItemLevel3}>
                      Inverter Data Not Available
                    </ListItem>
                  ) : (
                    <>
                      <ListItem
                        disablePadding
                        sx={styles.nestedItemLevel2}
                        selected={
                          selectedValue.projectDetail === "All Inverters"
                        }
                      >
                        <ListItemButton
                          onClick={() =>
                            handleSelectAllInverters({ route: true })
                          }
                        >
                          <ListItemText
                                            primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                            primary="All Inverters"
                          />
                        </ListItemButton>
                      </ListItem>

                      {inverterMappingArray.map((block) => (
                        <React.Fragment key={block.name}>
                          <ListItem disablePadding sx={styles.nestedItemLevel2}>
                            <ListItemButton
                              onClick={() =>
                                toggleMenu(block.name + "Deviation")
                              }
                            >
                              <ListItemText
                                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                primary={block.name}
                              />
                              {openMenus[block.name + "Deviation"] ? (
                                <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                              ) : (
                                <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                              )}
                            </ListItemButton>
                          </ListItem>

                          <Collapse
                            in={openMenus[block.name + "Deviation"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {block.subBlocks ? (
                                block.subBlocks.map((subBlock) => (
                                  <React.Fragment
                                    key={`${block.name}${subBlock.name}`}
                                  >
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel3}
                                    >
                                      <ListItemButton
                                        onClick={() =>
                                          toggleMenu(
                                            `${block.name}${subBlock.name}Deviation`
                                          )
                                        }
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                          primary={subBlock.name}
                                        />
                                        {openMenus[
                                          `${block.name}${subBlock.name}Deviation`
                                        ] ? (
                                          <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                        ) : (
                                          <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                        )}
                                      </ListItemButton>
                                    </ListItem>

                                    <Collapse
                                      in={
                                        openMenus[
                                          `${block.name}${subBlock.name}Deviation`
                                        ]
                                      }
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <List component="div" disablePadding>
                                        {subBlock.inverters?.length > 1 && (
                                          <ListItem
                                            disablePadding
                                            sx={styles.nestedItemLevel3}
                                            selected={
                                              selectedValue.projectDetail ===
                                                "All Inverter" &&
                                              scbsmbDetail.block ===
                                                block.name &&
                                              scbsmbDetail.sub_block ===
                                                subBlock.name
                                            }
                                          >
                                            <ListItemButton
                                              onClick={() =>
                                                handleSelectAllInverters({
                                                  block,
                                                  subBlock,
                                                  route: true,
                                                })
                                              }
                                            >
                                              <ListItemText
                                                primaryTypographyProps={{
                                                  variant: "body2",
                                                                    sx: { fontSize: "0.775rem" },
                                                }}
                                                primary="All Inverters"
                                              />
                                            </ListItemButton>
                                          </ListItem>
                                        )}

                                        {subBlock.inverters.map((inverter) =>
                                          subBlock.stacks ? (
                                            <React.Fragment
                                              key={`${block.name}-${subBlock.name}-${inverter.name}`}
                                            >
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel3}
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    toggleMenu(
                                                      `${block.name}${subBlock.name}${inverter.name}Deviation`
                                                    )
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary={inverter.name}
                                                  />
                                                  {openMenus[
                                                    `${block.name}${subBlock.name}${inverter.name}Deviation`
                                                  ] ? (
                                                    <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                                  ) : (
                                                    <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                                  )}
                                                </ListItemButton>
                                              </ListItem>

                                              <Collapse
                                                in={
                                                  openMenus[
                                                    `${block.name}${subBlock.name}${inverter.name}Deviation`
                                                  ]
                                                }
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <List
                                                  component="div"
                                                  disablePadding
                                                >
                                                  {inverter.stacks?.length >
                                                    1 && (
                                                    <ListItem
                                                      disablePadding
                                                      sx={
                                                        styles.nestedItemLevel3
                                                      }
                                                      selected={
                                                        selectedValue.projectDetail ===
                                                          "All Inverter" &&
                                                        scbsmbDetail.block ===
                                                          block.name &&
                                                        scbsmbDetail.sub_block ===
                                                          subBlock.name &&
                                                        scbsmbDetail.inverter ===
                                                          inverter.name
                                                      }
                                                    >
                                                      <ListItemButton
                                                        onClick={() =>
                                                          handleSelectAllInverters(
                                                            {
                                                              block,
                                                              subBlock,
                                                              inverter,
                                                              route: true,
                                                            }
                                                          )
                                                        }
                                                      >
                                                        <ListItemText
                                                          primaryTypographyProps={{
                                                            variant: "body2",
                                                                              sx: { fontSize: "0.775rem" },
                                                          }}
                                                          primary="All Stacks"
                                                        />
                                                      </ListItemButton>
                                                    </ListItem>
                                                  )}

                                                  {inverter.stacks.map(
                                                    (stack) => (
                                                      <ListItem
                                                        key={`${block.name}-${subBlock.name}-${inverter.name}-${stack}`}
                                                        disablePadding
                                                        sx={
                                                          styles.nestedItemLevel3
                                                        }
                                                        selected={
                                                          selectedValue.projectDetail ===
                                                            stack &&
                                                          scbsmbDetail.block ===
                                                            block.name &&
                                                          scbsmbDetail.sub_block ===
                                                            subBlock.name &&
                                                          scbsmbDetail.inverter ===
                                                            inverter.name
                                                        }
                                                      >
                                                        <ListItemButton
                                                          onClick={() =>
                                                            handleSelectStack(
                                                              block,
                                                              subBlock,
                                                              inverter,
                                                              stack
                                                            )
                                                          }
                                                        >
                                                          <ListItemText
                                                           primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                                            primary={stack}
                                                          />
                                                        </ListItemButton>
                                                      </ListItem>
                                                    )
                                                  )}
                                                </List>
                                              </Collapse>
                                            </React.Fragment>
                                          ) : (
                                            <ListItem
                                              key={`${block.name}-${subBlock.name}-${inverter}`}
                                              disablePadding
                                              sx={styles.nestedItemLevel3}
                                              selected={
                                                selectedValue.projectDetail ===
                                                  inverter &&
                                                scbsmbDetail.block ===
                                                  block.name &&
                                                scbsmbDetail.sub_block ===
                                                  subBlock.name
                                              }
                                            >
                                              <ListItemButton
                                                onClick={() =>
                                                  handleSelectInverter(
                                                    block,
                                                    subBlock,
                                                    inverter
                                                  )
                                                }
                                              >
                                                <ListItemText
                                                  primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                                  primary={inverter}
                                                />
                                              </ListItemButton>
                                            </ListItem>
                                          )
                                        )}
                                      </List>
                                    </Collapse>
                                  </React.Fragment>
                                ))
                              ) : (
                                <>
                                  {block.inverters?.length > 1 && (
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel3}
                                      selected={
                                        selectedValue.projectDetail ===
                                          "All Inverter" &&
                                        scbsmbDetail.block === block.name
                                      }
                                    >
                                      <ListItemButton
                                        onClick={() =>
                                          handleSelectAllInverters({
                                            block,
                                            route: true,
                                          })
                                        }
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                          primary="All Inverters"
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  )}

                                  {block.inverters.map((inverter) =>
                                    block.inverters[0]?.stacks ? (
                                      <React.Fragment
                                        key={`${block.name}-${inverter.name}`}
                                      >
                                        <ListItem
                                          disablePadding
                                          sx={styles.nestedItemLevel3}
                                        >
                                          <ListItemButton
                                            onClick={() =>
                                              toggleMenu(
                                                `${block.name}${inverter.name}Deviation`
                                              )
                                            }
                                          >
                                            <ListItemText
                                              primaryTypographyProps={{
                                                variant: "body2",
                                                                  sx: { fontSize: "0.775rem" },
                                              }}
                                              primary={inverter.name}
                                            />
                                            {openMenus[
                                              `${block.name}${inverter.name}Deviation`
                                            ] ? (
                                              <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                            ) : (
                                              <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                            )}
                                          </ListItemButton>
                                        </ListItem>

                                        <Collapse
                                          in={
                                            openMenus[
                                              `${block.name}${inverter.name}Deviation`
                                            ]
                                          }
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          <List component="div" disablePadding>
                                            {inverter.stacks?.length > 1 && (
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel3}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                    "All Inverter" &&
                                                  scbsmbDetail.block ===
                                                    block.name &&
                                                  scbsmbDetail.inverter ===
                                                    inverter.name
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    handleSelectAllInverters({
                                                      block,
                                                      subBlock: null,
                                                      inverter,
                                                      route: true,
                                                    })
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary="All Stacks"
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            )}

                                            {inverter.stacks.map((stack) => (
                                              <ListItem
                                                key={`${block.name}-${inverter.name}-${stack}`}
                                                disablePadding
                                                sx={styles.nestedItemLevel3}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                    stack &&
                                                  scbsmbDetail.block ===
                                                    block.name &&
                                                  scbsmbDetail.inverter ===
                                                    inverter.name
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() =>
                                                    handleSelectStack(
                                                      block,
                                                      null,
                                                      inverter,
                                                      stack
                                                    )
                                                  }
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary={stack}
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            ))}
                                          </List>
                                        </Collapse>
                                      </React.Fragment>
                                    ) : (
                                      <ListItem
                                        key={`${block.name}-${inverter}`}
                                        disablePadding
                                        sx={styles.nestedItemLevel3}
                                        selected={
                                          selectedValue.projectDetail ===
                                            inverter &&
                                          scbsmbDetail.block === block.name
                                        }
                                      >
                                        <ListItemButton
                                          onClick={() =>
                                            handleSelectInverter(
                                              block,
                                              null,
                                              inverter
                                            )
                                          }
                                        >
                                          <ListItemText
                                            primaryTypographyProps={{
                                              variant: "body2",
                                                                sx: { fontSize: "0.775rem" },
                                            }}
                                            primary={inverter}
                                          />
                                        </ListItemButton>
                                      </ListItem>
                                    )
                                  )}
                                </>
                              )}
                            </List>
                          </Collapse>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </List>
              </Collapse>
              {projectDetail && (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton
                    onClick={() => {
                      if (!scbSmbMappingArray) {
                        dispatch(scbSmbMappingArrayAction(databaseStr));
                      }
                      toggleMenu("scbString");
                    }}
                  >
                    <ListItemIcon>
                      <Cable fontSize="small" sx={{ fontSize: "0.875rem" }} />
                    </ListItemIcon>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary={`${
                        projectDetail?.plantDetail?.string || ""
                      } Deviation`}
                    />
                    {openMenus?.scbString ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              <Collapse in={openMenus?.scbString} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {scbSmbMappingLoader ? (
                    <ListItem sx={{ justifyContent: "center" }}>
                      <FetchProjectDetailLoader width="25px" />
                    </ListItem>
                  ) : !scbSmbMappingArray ? (
                    <ListItem sx={styles.nestedItemLevel3}>
                      {projectDetail?.plantDetail?.string || ""} Data Not Found
                    </ListItem>
                  ) : scbSmbMappingArray?.length === 0 ? (
                    <ListItem sx={styles.nestedItemLevel3}>
                      {projectDetail?.plantDetail?.string || ""} Data Not
                      Available
                    </ListItem>
                  ) : (
                    <>
                      {scbSmbMappingArray.map((block) => (
                        <React.Fragment key={block.name}>
                          <ListItem disablePadding sx={styles.nestedItemLevel2}>
                            <ListItemButton
                              onClick={() => toggleMenu(`block-${block.name}`)}
                            >
                              <ListItemText
                                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                primary={block.name}
                              />
                              {openMenus[`block-${block.name}`] ? (
                                <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                              ) : (
                                <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                              )}
                            </ListItemButton>
                          </ListItem>

                          <Collapse
                            in={openMenus[`block-${block.name}`]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {block.subBlocks ? (
                                block.subBlocks.map((subBlock) => (
                                  <React.Fragment
                                    key={`${block.name}-${subBlock.name}`}
                                  >
                                    <ListItem
                                      disablePadding
                                      sx={styles.nestedItemLevel3}
                                    >
                                      <ListItemButton
                                        onClick={() =>
                                          toggleMenu(
                                            `subBlock-${block.name}-${subBlock.name}`
                                          )
                                        }
                                      >
                                        <ListItemText
                                          primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                          primary={subBlock.name}
                                        />
                                        {openMenus[
                                          `subBlock-${block.name}-${subBlock.name}`
                                        ] ? (
                                          <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                        ) : (
                                          <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                        )}
                                      </ListItemButton>
                                    </ListItem>

                                    <Collapse
                                      in={
                                        openMenus[
                                          `subBlock-${block.name}-${subBlock.name}`
                                        ]
                                      }
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <List component="div" disablePadding>
                                        {/* All Strings option for the sub-block */}
                                        <ListItem
                                          disablePadding
                                          sx={styles.nestedItemLevel4}
                                          selected={
                                            selectedValue.projectDetail ===
                                              `All ${projectDetail?.plantDetail?.string}` &&
                                            scbsmbDetail.block === block.name &&
                                            scbsmbDetail.sub_block ===
                                              subBlock.name &&
                                            !scbsmbDetail.inverter &&
                                            !scbsmbDetail.stack
                                          }
                                        >
                                          <ListItemButton
                                            onClick={() => {
                                              setSelectedValue({
                                                ...selectedValue,
                                                projectDetail: `All ${projectDetail?.plantDetail?.string}`,
                                              });

                                              setscbsmbDetail({
                                                block: block.name,
                                                sub_block: subBlock.name,
                                                inverter: null,
                                                inverterType: null,
                                                stack: null,
                                                scbsmb: null,
                                                scbsmbType: `${
                                                  projectDetail?.plantDetail
                                                    ?.string || ""
                                                }`,
                                              });

                                              if (
                                                location.pathname !==
                                                PageURL.SCBSMB_LOSS
                                              ) {
                                                navigate(
                                                  `${
                                                    PageURL.SCBSMB_LOSS
                                                  }?${serachParams.toString()}`
                                                );
                                              }
                                            }}
                                          >
                                            <ListItemText
                                              primaryTypographyProps={{
                                                variant: "body2",
                                                                  sx: { fontSize: "0.775rem" },
                                              }}
                                              primary={`All ${projectDetail?.plantDetail?.string}`}
                                            />
                                          </ListItemButton>
                                        </ListItem>

                                        {subBlock.inverters?.map((inverter) => (
                                          <React.Fragment
                                            key={`${block.name}-${subBlock.name}-${inverter.name}`}
                                          >
                                            <ListItem
                                              disablePadding
                                              sx={styles.nestedItemLevel4}
                                            >
                                              <ListItemButton
                                                onClick={() =>
                                                  toggleMenu(
                                                    `inverter-${block.name}-${subBlock.name}-${inverter.name}`
                                                  )
                                                }
                                              >
                                                <ListItemText
                                                  primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                                  primary={inverter.name}
                                                />
                                                {openMenus[
                                                  `inverter-${block.name}-${subBlock.name}-${inverter.name}`
                                                ] ? (
                                                  <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                                ) : (
                                                  <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                                )}
                                              </ListItemButton>
                                            </ListItem>

                                            <Collapse
                                              in={
                                                openMenus[
                                                  `inverter-${block.name}-${subBlock.name}-${inverter.name}`
                                                ]
                                              }
                                              timeout="auto"
                                              unmountOnExit
                                            >
                                              <List
                                                component="div"
                                                disablePadding
                                              >
                                                {/* All Strings option for the inverter */}
                                                {inverter.listScbsmb?.length >
                                                  1 &&
                                                  projectDetail?.plantDetail
                                                    ?.string !== "SMB" && (
                                                    <ListItem
                                                      disablePadding
                                                      sx={
                                                        styles.nestedItemLevel5
                                                      }
                                                      selected={
                                                        selectedValue.projectDetail ===
                                                          `All ${
                                                            projectDetail
                                                              ?.plantDetail
                                                              ?.string || ""
                                                          }` &&
                                                        scbsmbDetail.block ===
                                                          block.name &&
                                                        scbsmbDetail.sub_block ===
                                                          subBlock.name &&
                                                        scbsmbDetail.inverter ===
                                                          inverter.name
                                                      }
                                                    >
                                                      <ListItemButton
                                                        onClick={() => {
                                                          setSelectedValue({
                                                            ...selectedValue,
                                                            projectDetail: `All ${
                                                              projectDetail
                                                                ?.plantDetail
                                                                ?.string || ""
                                                            }`,
                                                          });

                                                          setscbsmbDetail({
                                                            block: block.name,
                                                            sub_block:
                                                              subBlock.name,
                                                            inverter:
                                                              inverter.name,
                                                            inverterType:
                                                              inverter.inverterType,
                                                            stack: null,
                                                            scbsmb: null,
                                                            scbsmbType: `${
                                                              projectDetail
                                                                ?.plantDetail
                                                                ?.string || ""
                                                            }`,
                                                          });

                                                          if (
                                                            location.pathname !==
                                                            PageURL.SCBSMB_LOSS
                                                          ) {
                                                            navigate(
                                                              `${
                                                                PageURL.SCBSMB_LOSS
                                                              }?${serachParams.toString()}`
                                                            );
                                                          }
                                                        }}
                                                      >
                                                        <ListItemText
                                                          primaryTypographyProps={{
                                                            variant: "body2",
                                                                              sx: { fontSize: "0.775rem" },
                                                          }}
                                                          primary={`All ${
                                                            projectDetail
                                                              ?.plantDetail
                                                              ?.string || ""
                                                          }`}
                                                        />
                                                      </ListItemButton>
                                                    </ListItem>
                                                  )}

                                                {/* HeatMap option */}
                                                <ListItem
                                                  disablePadding
                                                  sx={styles.nestedItemLevel5}
                                                  selected={
                                                    selectedValue.projectDetail ===
                                                      "HeatMap" &&
                                                    scbsmbDetail.block ===
                                                      block.name &&
                                                    scbsmbDetail.sub_block ===
                                                      subBlock.name &&
                                                    scbsmbDetail.inverter ===
                                                      inverter.name
                                                  }
                                                >
                                                  <ListItemButton
                                                    onClick={() => {
                                                      setSelectedValue({
                                                        ...selectedValue,
                                                        projectDetail:
                                                          "HeatMap",
                                                      });

                                                      setscbsmbDetail({
                                                        block: block.name,
                                                        sub_block:
                                                          subBlock.name,
                                                        inverter: inverter.name,
                                                        inverterType:
                                                          inverter.inverterType,
                                                        stack: null,
                                                        scbsmb: null,
                                                        heatmap: true,
                                                        scbsmbType: `${
                                                          projectDetail
                                                            ?.plantDetail
                                                            ?.string || ""
                                                        }`,
                                                      });

                                                      if (
                                                        location.pathname !==
                                                        PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                      ) {
                                                        navigate(
                                                          `${
                                                            PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                          }?${serachParams.toString()}`
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    <ListItemText
                                                      primaryTypographyProps={{
                                                        variant: "body2",
                                                                          sx: { fontSize: "0.775rem" },
                                                      }}
                                                      primary="HeatMap"
                                                    />
                                                  </ListItemButton>
                                                </ListItem>

                                                {/* Handle both direct SCB/SMB list and stacks */}
                                                {inverter.listScbsmb ? (
                                                  <>
                                                    {/* Direct SCB/SMB list */}
                                                    {inverter.listScbsmb.map(
                                                      (scbSmb) => (
                                                        <ListItem
                                                          key={`${block.name}-${subBlock.name}-${inverter.name}-${scbSmb}`}
                                                          disablePadding
                                                          sx={
                                                            styles.nestedItemLevel5
                                                          }
                                                          selected={
                                                            selectedValue.projectDetail ===
                                                              scbSmb &&
                                                            scbsmbDetail.block ===
                                                              block.name &&
                                                            scbsmbDetail.sub_block ===
                                                              subBlock.name &&
                                                            scbsmbDetail.inverter ===
                                                              inverter.name &&
                                                            scbsmbDetail.scbsmb ===
                                                              scbSmb
                                                          }
                                                        >
                                                          <ListItemButton
                                                            onClick={() => {
                                                              setSelectedValue({
                                                                ...selectedValue,
                                                                projectDetail:
                                                                  scbSmb,
                                                              });

                                                              setscbsmbDetail({
                                                                block:
                                                                  block.name,
                                                                sub_block:
                                                                  subBlock.name,
                                                                inverter:
                                                                  inverter.name,
                                                                inverterType:
                                                                  inverter.inverterType,
                                                                stack: null,
                                                                scbsmb: scbSmb,
                                                                scbsmbType: `${
                                                                  projectDetail
                                                                    ?.plantDetail
                                                                    ?.string ||
                                                                  ""
                                                                }`,
                                                              });

                                                              if (
                                                                location.pathname !==
                                                                PageURL.SCBSMB_LOSS
                                                              ) {
                                                                navigate(
                                                                  `${
                                                                    PageURL.SCBSMB_LOSS
                                                                  }?${serachParams.toString()}`
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            <ListItemText
                                                              primaryTypographyProps={{
                                                                variant:
                                                                  "body2",
                                                                                    sx: { fontSize: "0.775rem" },
                                                              }}
                                                              primary={scbSmb}
                                                            />
                                                          </ListItemButton>
                                                        </ListItem>
                                                      )
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {/* Stacks handling */}
                                                    {inverter.stacks?.map(
                                                      (stack) => (
                                                        <React.Fragment
                                                          key={`${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`}
                                                        >
                                                          <ListItem
                                                            disablePadding
                                                            sx={
                                                              styles.nestedItemLevel4
                                                            }
                                                          >
                                                            <ListItemButton
                                                              onClick={() =>
                                                                toggleMenu(
                                                                  `stack-${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                                                                )
                                                              }
                                                            >
                                                              <ListItemText
                                                                primaryTypographyProps={{
                                                                  variant:
                                                                    "body2",
                                                                                      sx: { fontSize: "0.775rem" },
                                                                }}
                                                                primary={
                                                                  stack.name
                                                                }
                                                              />
                                                              {openMenus[
                                                                `stack-${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                                                              ] ? (
                                                                <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                                              ) : (
                                                                <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                                              )}
                                                            </ListItemButton>
                                                          </ListItem>

                                                          <Collapse
                                                            in={
                                                              openMenus[
                                                                `stack-${block.name}-${subBlock.name}-${inverter.name}-${stack.name}`
                                                              ]
                                                            }
                                                            timeout="auto"
                                                            unmountOnExit
                                                          >
                                                            <List
                                                              component="div"
                                                              disablePadding
                                                            >
                                                              {/* All Strings option for the stack */}
                                                              {stack.listScbsmb
                                                                ?.length > 1 &&
                                                                projectDetail
                                                                  ?.plantDetail
                                                                  ?.string !==
                                                                  "SMB" && (
                                                                  <ListItem
                                                                    disablePadding
                                                                    sx={
                                                                      styles.nestedItemLevel5
                                                                    }
                                                                    selected={
                                                                      selectedValue.projectDetail ===
                                                                        `All ${
                                                                          projectDetail
                                                                            ?.plantDetail
                                                                            ?.string ||
                                                                          ""
                                                                        }` &&
                                                                      scbsmbDetail.block ===
                                                                        block.name &&
                                                                      scbsmbDetail.sub_block ===
                                                                        subBlock.name &&
                                                                      scbsmbDetail.inverter ===
                                                                        inverter.name &&
                                                                      scbsmbDetail.stack ===
                                                                        stack.name
                                                                    }
                                                                  >
                                                                    <ListItemButton
                                                                      onClick={() => {
                                                                        setSelectedValue(
                                                                          {
                                                                            ...selectedValue,
                                                                            projectDetail: `All ${
                                                                              projectDetail
                                                                                ?.plantDetail
                                                                                ?.string ||
                                                                              ""
                                                                            }`,
                                                                          }
                                                                        );

                                                                        setscbsmbDetail(
                                                                          {
                                                                            block:
                                                                              block.name,
                                                                            sub_block:
                                                                              subBlock.name,
                                                                            inverter:
                                                                              inverter.name,
                                                                            inverterType:
                                                                              inverter.inverterType,
                                                                            stack:
                                                                              stack.name,
                                                                            scbsmb:
                                                                              null,
                                                                            scbsmbType: `${
                                                                              projectDetail
                                                                                ?.plantDetail
                                                                                ?.string ||
                                                                              ""
                                                                            }`,
                                                                          }
                                                                        );

                                                                        if (
                                                                          location.pathname !==
                                                                          PageURL.SCBSMB_LOSS
                                                                        ) {
                                                                          navigate(
                                                                            `${
                                                                              PageURL.SCBSMB_LOSS
                                                                            }?${serachParams.toString()}`
                                                                          );
                                                                        }
                                                                      }}
                                                                    >
                                                                      <ListItemText
                                                                        primaryTypographyProps={{
                                                                          variant:
                                                                            "body2",
                                                                                              sx: { fontSize: "0.775rem" },
                                                                        }}
                                                                        primary={`All ${
                                                                          projectDetail
                                                                            ?.plantDetail
                                                                            ?.string ||
                                                                          ""
                                                                        }`}
                                                                      />
                                                                    </ListItemButton>
                                                                  </ListItem>
                                                                )}

                                                              {/* HeatMap option for stack */}
                                                              <ListItem
                                                                disablePadding
                                                                sx={
                                                                  styles.nestedItemLevel5
                                                                }
                                                                selected={
                                                                  selectedValue.projectDetail ===
                                                                    "HeatMap" &&
                                                                  scbsmbDetail.block ===
                                                                    block.name &&
                                                                  scbsmbDetail.sub_block ===
                                                                    subBlock.name &&
                                                                  scbsmbDetail.inverter ===
                                                                    inverter.name &&
                                                                  scbsmbDetail.stack ===
                                                                    stack.name
                                                                }
                                                              >
                                                                <ListItemButton
                                                                  onClick={() => {
                                                                    setSelectedValue(
                                                                      {
                                                                        ...selectedValue,
                                                                        projectDetail:
                                                                          "HeatMap",
                                                                      }
                                                                    );

                                                                    setscbsmbDetail(
                                                                      {
                                                                        block:
                                                                          block.name,
                                                                        sub_block:
                                                                          subBlock.name,
                                                                        inverter:
                                                                          inverter.name,
                                                                        inverterType:
                                                                          inverter.inverterType,
                                                                        stack:
                                                                          stack.name,
                                                                        scbsmb:
                                                                          null,
                                                                        heatmap: true,
                                                                        scbsmbType: `${
                                                                          projectDetail
                                                                            ?.plantDetail
                                                                            ?.string ||
                                                                          ""
                                                                        }`,
                                                                      }
                                                                    );

                                                                    if (
                                                                      location.pathname !==
                                                                      PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                                    ) {
                                                                      navigate(
                                                                        `${
                                                                          PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                                        }?${serachParams.toString()}`
                                                                      );
                                                                    }
                                                                  }}
                                                                >
                                                                  <ListItemText
                                                                    primaryTypographyProps={{
                                                                      variant:
                                                                        "body2",
                                                                                          sx: { fontSize: "0.775rem" },
                                                                    }}
                                                                    primary="HeatMap"
                                                                  />
                                                                </ListItemButton>
                                                              </ListItem>

                                                              {/* SCB/SMB list for stack */}
                                                              {stack.listScbsmb?.map(
                                                                (scbSmb) => (
                                                                  <ListItem
                                                                    key={`${block.name}-${subBlock.name}-${inverter.name}-${stack.name}-${scbSmb}`}
                                                                    disablePadding
                                                                    sx={
                                                                      styles.nestedItemLevel5
                                                                    }
                                                                    selected={
                                                                      selectedValue.projectDetail ===
                                                                        scbSmb &&
                                                                      scbsmbDetail.block ===
                                                                        block.name &&
                                                                      scbsmbDetail.sub_block ===
                                                                        subBlock.name &&
                                                                      scbsmbDetail.inverter ===
                                                                        inverter.name &&
                                                                      scbsmbDetail.stack ===
                                                                        stack.name &&
                                                                      scbsmbDetail.scbsmb ===
                                                                        scbSmb
                                                                    }
                                                                  >
                                                                    <ListItemButton
                                                                      onClick={() => {
                                                                        setSelectedValue(
                                                                          {
                                                                            ...selectedValue,
                                                                            projectDetail:
                                                                              scbSmb,
                                                                          }
                                                                        );

                                                                        setscbsmbDetail(
                                                                          {
                                                                            block:
                                                                              block.name,
                                                                            sub_block:
                                                                              subBlock.name,
                                                                            inverter:
                                                                              inverter.name,
                                                                            inverterType:
                                                                              inverter.inverterType,
                                                                            stack:
                                                                              stack.name,
                                                                            scbsmb:
                                                                              scbSmb,
                                                                            scbsmbType: `${
                                                                              projectDetail
                                                                                ?.plantDetail
                                                                                ?.string ||
                                                                              ""
                                                                            }`,
                                                                          }
                                                                        );

                                                                        if (
                                                                          location.pathname !==
                                                                          PageURL.SCBSMB_LOSS
                                                                        ) {
                                                                          navigate(
                                                                            `${
                                                                              PageURL.SCBSMB_LOSS
                                                                            }?${serachParams.toString()}`
                                                                          );
                                                                        }
                                                                      }}
                                                                    >
                                                                      <ListItemText
                                                                        primaryTypographyProps={{
                                                                          variant:
                                                                            "body2",
                                                                                              sx: { fontSize: "0.775rem" },
                                                                        }}
                                                                        primary={
                                                                          scbSmb
                                                                        }
                                                                      />
                                                                    </ListItemButton>
                                                                  </ListItem>
                                                                )
                                                              )}
                                                            </List>
                                                          </Collapse>
                                                        </React.Fragment>
                                                      )
                                                    )}
                                                  </>
                                                )}
                                              </List>
                                            </Collapse>
                                          </React.Fragment>
                                        ))}
                                      </List>
                                    </Collapse>
                                  </React.Fragment>
                                ))
                              ) : (
                                <>
                                  {/* For blocks without subBlocks */}
                                  {/* All Strings option for the block */}
                                  {/* <ListItem

                                    disablePadding
                                    sx={styles.nestedItemLevel3}
                                    selected={
                                      selectedValue.projectDetail ===
                                        `All ${projectDetail?.plantDetail?.string}` &&
                                      scbsmbDetail.block === block.name &&
                                      !scbsmbDetail.sub_block &&
                                      !scbsmbDetail.inverter &&
                                      !scbsmbDetail.stack
                                    }
                                  >
                                    <ListItemButton
                                      onClick={() => {
                                        setSelectedValue({
                                          ...selectedValue,
                                          projectDetail: `All ${projectDetail?.plantDetail?.string}`,
                                        });

                                        setscbsmbDetail({
                                          block: block.name,
                                          sub_block: null,
                                          inverter: null,
                                          inverterType: null,
                                          stack: null,
                                          scbsmb: null,
                                          scbsmbType: `${
                                            projectDetail?.plantDetail
                                              ?.string || ""
                                          }`,
                                        });

                                        if (
                                          location.pathname !==
                                          PageURL.SCBSMB_LOSS
                                        ) {
                                          navigate(
                                            `${
                                              PageURL.SCBSMB_LOSS
                                            }?${serachParams.toString()}`
                                          );
                                        }
                                      }}
                                    >
                                      <ListItemText

                                        primaryTypographyProps={{
                                          variant: "body2",
                                        }}
                                        primary={`All ${projectDetail?.plantDetail?.string}`}
                                      />
                                    </ListItemButton>
                                  </ListItem> */}

                                  {block.inverters?.map((inverter) => (
                                    <React.Fragment
                                      key={`${block.name}-${inverter.name}`}
                                    >
                                      <ListItem
                                        disablePadding
                                        sx={styles.nestedItemLevel3}
                                      >
                                        <ListItemButton
                                          onClick={() =>
                                            toggleMenu(
                                              `inverter-${block.name}-${inverter.name}`
                                            )
                                          }
                                        >
                                          <ListItemText
                                            primaryTypographyProps={{
                                              variant: "body2",
                                                                sx: { fontSize: "0.775rem" },
                                            }}
                                            primary={inverter.name}
                                          />
                                          {openMenus[
                                            `inverter-${block.name}-${inverter.name}`
                                          ] ? (
                                            <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                          ) : (
                                            <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                          )}
                                        </ListItemButton>
                                      </ListItem>

                                      <Collapse
                                        in={
                                          openMenus[
                                            `inverter-${block.name}-${inverter.name}`
                                          ]
                                        }
                                        timeout="auto"
                                        unmountOnExit
                                      >
                                        <List component="div" disablePadding>
                                          {/* All Strings option for the inverter */}
                                          {inverter.listScbsmb?.length > 1 &&
                                            projectDetail?.plantDetail
                                              ?.string !== "SMB" && (
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel4}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                    `All ${
                                                      projectDetail?.plantDetail
                                                        ?.string || ""
                                                    }` &&
                                                  scbsmbDetail.block ===
                                                    block.name &&
                                                  scbsmbDetail.inverter ===
                                                    inverter.name
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() => {
                                                    setSelectedValue({
                                                      ...selectedValue,
                                                      projectDetail: `All ${
                                                        projectDetail
                                                          ?.plantDetail
                                                          ?.string || ""
                                                      }`,
                                                    });

                                                    setscbsmbDetail({
                                                      block: block.name,
                                                      sub_block: null,
                                                      inverter: inverter.name,
                                                      inverterType:
                                                        inverter.inverterType,
                                                      stack: null,
                                                      scbsmb: null,
                                                      scbsmbType: `${
                                                        projectDetail
                                                          ?.plantDetail
                                                          ?.string || ""
                                                      }`,
                                                    });

                                                    if (
                                                      location.pathname !==
                                                      PageURL.SCBSMB_LOSS
                                                    ) {
                                                      navigate(
                                                        `${
                                                          PageURL.SCBSMB_LOSS
                                                        }?${serachParams.toString()}`
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary={`All ${
                                                      projectDetail?.plantDetail
                                                        ?.string || ""
                                                    }`}
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            )}

                                          {/* Handle both direct SCB/SMB list and stacks */}
                                          {inverter.listScbsmb ? (
                                            <>
                                              {/* HeatMap option */}
                                              <ListItem
                                                disablePadding
                                                sx={styles.nestedItemLevel4}
                                                selected={
                                                  selectedValue.projectDetail ===
                                                    "HeatMap" &&
                                                  scbsmbDetail.block ===
                                                    block.name &&
                                                  scbsmbDetail.inverter ===
                                                    inverter.name
                                                }
                                              >
                                                <ListItemButton
                                                  onClick={() => {
                                                    setSelectedValue({
                                                      ...selectedValue,
                                                      projectDetail: "HeatMap",
                                                    });

                                                    setscbsmbDetail({
                                                      block: block.name,
                                                      sub_block: null,
                                                      inverter: inverter.name,
                                                      inverterType:
                                                        inverter.inverterType,
                                                      stack: null,
                                                      scbsmb: null,
                                                      heatmap: true,
                                                      scbsmbType: `${
                                                        projectDetail
                                                          ?.plantDetail
                                                          ?.string || ""
                                                      }`,
                                                    });

                                                    if (
                                                      location.pathname !==
                                                      PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                    ) {
                                                      navigate(
                                                        `${
                                                          PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                        }?${serachParams.toString()}`
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <ListItemText
                                                    primaryTypographyProps={{
                                                      variant: "body2",
                                                                        sx: { fontSize: "0.775rem" },
                                                    }}
                                                    primary="HeatMap"
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                              {/* Direct SCB/SMB list */}
                                              {inverter.listScbsmb.map(
                                                (scbSmb) => (
                                                  <ListItem
                                                    key={`${block.name}-${inverter.name}-${scbSmb}`}
                                                    disablePadding
                                                    sx={styles.nestedItemLevel4}
                                                    selected={
                                                      selectedValue.projectDetail ===
                                                        scbSmb &&
                                                      scbsmbDetail.block ===
                                                        block.name &&
                                                      scbsmbDetail.inverter ===
                                                        inverter.name &&
                                                      scbsmbDetail.scbsmb ===
                                                        scbSmb
                                                    }
                                                  >
                                                    <ListItemButton
                                                      onClick={() => {
                                                        setSelectedValue({
                                                          ...selectedValue,
                                                          projectDetail: scbSmb,
                                                        });

                                                        setscbsmbDetail({
                                                          block: block.name,
                                                          sub_block: null,
                                                          inverter:
                                                            inverter.name,
                                                          inverterType:
                                                            inverter.inverterType,
                                                          stack: null,
                                                          scbsmb: scbSmb,
                                                          scbsmbType: `${
                                                            projectDetail
                                                              ?.plantDetail
                                                              ?.string || ""
                                                          }`,
                                                        });

                                                        if (
                                                          location.pathname !==
                                                          PageURL.SCBSMB_LOSS
                                                        ) {
                                                          navigate(
                                                            `${
                                                              PageURL.SCBSMB_LOSS
                                                            }?${serachParams.toString()}`
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <ListItemText
                                                        primaryTypographyProps={{
                                                          variant: "body2",
                                                                            sx: { fontSize: "0.775rem" },
                                                        }}
                                                        primary={scbSmb}
                                                      />
                                                    </ListItemButton>
                                                  </ListItem>
                                                )
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {/* Stacks handling */}
                                              {inverter.stacks?.map((stack) => (
                                                <React.Fragment
                                                  key={`${block.name}-${inverter.name}-${stack.name}`}
                                                >
                                                  <ListItem
                                                    disablePadding
                                                    sx={styles.nestedItemLevel4}
                                                  >
                                                    <ListItemButton
                                                      onClick={() =>
                                                        toggleMenu(
                                                          `stack-${block.name}-${inverter.name}-${stack.name}`
                                                        )
                                                      }
                                                    >
                                                      <ListItemText
                                                        primaryTypographyProps={{
                                                          variant: "body2",
                                                                            sx: { fontSize: "0.775rem" },
                                                        }}
                                                        primary={stack.name}
                                                      />
                                                      {openMenus[
                                                        `stack-${block.name}-${inverter.name}-${stack.name}`
                                                      ] ? (
                                                        <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                                                      ) : (
                                                        <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                                                      )}
                                                    </ListItemButton>
                                                  </ListItem>

                                                  <Collapse
                                                    in={
                                                      openMenus[
                                                        `stack-${block.name}-${inverter.name}-${stack.name}`
                                                      ]
                                                    }
                                                    timeout="auto"
                                                    unmountOnExit
                                                  >
                                                    <List
                                                      component="div"
                                                      disablePadding
                                                    >
                                                      {/* All Strings option for the stack */}
                                                      {stack.listScbsmb
                                                        ?.length > 1 &&
                                                        projectDetail
                                                          ?.plantDetail
                                                          ?.string !==
                                                          "SMB" && (
                                                          <ListItem
                                                            disablePadding
                                                            sx={
                                                              styles.nestedItemLevel5
                                                            }
                                                            selected={
                                                              selectedValue.projectDetail ===
                                                                `All ${
                                                                  projectDetail
                                                                    ?.plantDetail
                                                                    ?.string ||
                                                                  ""
                                                                }` &&
                                                              scbsmbDetail.block ===
                                                                block.name &&
                                                              scbsmbDetail.inverter ===
                                                                inverter.name &&
                                                              scbsmbDetail.stack ===
                                                                stack.name
                                                            }
                                                          >
                                                            <ListItemButton
                                                              onClick={() => {
                                                                setSelectedValue(
                                                                  {
                                                                    ...selectedValue,
                                                                    projectDetail: `All ${
                                                                      projectDetail
                                                                        ?.plantDetail
                                                                        ?.string ||
                                                                      ""
                                                                    }`,
                                                                  }
                                                                );

                                                                setscbsmbDetail(
                                                                  {
                                                                    block:
                                                                      block.name,
                                                                    sub_block:
                                                                      null,
                                                                    inverter:
                                                                      inverter.name,
                                                                    inverterType:
                                                                      inverter.inverterType,
                                                                    stack:
                                                                      stack.name,
                                                                    scbsmb:
                                                                      null,
                                                                    scbsmbType: `${
                                                                      projectDetail
                                                                        ?.plantDetail
                                                                        ?.string ||
                                                                      ""
                                                                    }`,
                                                                  }
                                                                );

                                                                if (
                                                                  location.pathname !==
                                                                  PageURL.SCBSMB_LOSS
                                                                ) {
                                                                  navigate(
                                                                    `${
                                                                      PageURL.SCBSMB_LOSS
                                                                    }?${serachParams.toString()}`
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <ListItemText
                                                                primaryTypographyProps={{
                                                                  variant:
                                                                    "body2",
                                                                                      sx: { fontSize: "0.775rem" },
                                                                }}
                                                                primary={`All ${
                                                                  projectDetail
                                                                    ?.plantDetail
                                                                    ?.string ||
                                                                  ""
                                                                }`}
                                                              />
                                                            </ListItemButton>
                                                          </ListItem>
                                                        )}

                                                      {/* HeatMap option for stack */}
                                                      <ListItem
                                                        disablePadding
                                                        sx={
                                                          styles.nestedItemLevel5
                                                        }
                                                        selected={
                                                          selectedValue.projectDetail ===
                                                            "HeatMap" &&
                                                          scbsmbDetail.block ===
                                                            block.name &&
                                                          scbsmbDetail.inverter ===
                                                            inverter.name &&
                                                          scbsmbDetail.stack ===
                                                            stack.name
                                                        }
                                                      >
                                                        <ListItemButton
                                                          onClick={() => {
                                                            setSelectedValue({
                                                              ...selectedValue,
                                                              projectDetail:
                                                                "HeatMap",
                                                            });

                                                            setscbsmbDetail({
                                                              block: block.name,
                                                              sub_block: null,
                                                              inverter:
                                                                inverter.name,
                                                              inverterType:
                                                                inverter.inverterType,
                                                              stack: stack.name,
                                                              scbsmb: null,
                                                              heatmap: true,
                                                              scbsmbType: `${
                                                                projectDetail
                                                                  ?.plantDetail
                                                                  ?.string || ""
                                                              }`,
                                                            });

                                                            if (
                                                              location.pathname !==
                                                              PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                            ) {
                                                              navigate(
                                                                `${
                                                                  PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM
                                                                }?${serachParams.toString()}`
                                                              );
                                                            }
                                                          }}
                                                        >
                                                          <ListItemText
                                                           primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                                                            primary="HeatMap"
                                                          />
                                                        </ListItemButton>
                                                      </ListItem>

                                                      {/* SCB/SMB list for stack */}
                                                      {stack.listScbsmb?.map(
                                                        (scbSmb) => (
                                                          <ListItem
                                                            key={`${block.name}-${inverter.name}-${stack.name}-${scbSmb}`}
                                                            disablePadding
                                                            sx={
                                                              styles.nestedItemLevel5
                                                            }
                                                            selected={
                                                              selectedValue.projectDetail ===
                                                                scbSmb &&
                                                              scbsmbDetail.block ===
                                                                block.name &&
                                                              scbsmbDetail.inverter ===
                                                                inverter.name &&
                                                              scbsmbDetail.stack ===
                                                                stack.name &&
                                                              scbsmbDetail.scbsmb ===
                                                                scbSmb
                                                            }
                                                          >
                                                            <ListItemButton
                                                              onClick={() => {
                                                                setSelectedValue(
                                                                  {
                                                                    ...selectedValue,
                                                                    projectDetail:
                                                                      scbSmb,
                                                                  }
                                                                );

                                                                setscbsmbDetail(
                                                                  {
                                                                    block:
                                                                      block.name,
                                                                    sub_block:
                                                                      null,
                                                                    inverter:
                                                                      inverter.name,
                                                                    inverterType:
                                                                      inverter.inverterType,
                                                                    stack:
                                                                      stack.name,
                                                                    scbsmb:
                                                                      scbSmb,
                                                                    scbsmbType: `${
                                                                      projectDetail
                                                                        ?.plantDetail
                                                                        ?.string ||
                                                                      ""
                                                                    }`,
                                                                  }
                                                                );

                                                                if (
                                                                  location.pathname !==
                                                                  PageURL.SCBSMB_LOSS
                                                                ) {
                                                                  navigate(
                                                                    `${
                                                                      PageURL.SCBSMB_LOSS
                                                                    }?${serachParams.toString()}`
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <ListItemText
                                                                primaryTypographyProps={{
                                                                  variant:
                                                                    "body2",
                                                                                      sx: { fontSize: "0.775rem" },
                                                                }}
                                                                primary={scbSmb}
                                                              />
                                                            </ListItemButton>
                                                          </ListItem>
                                                        )
                                                      )}
                                                    </List>
                                                  </Collapse>
                                                </React.Fragment>
                                              ))}
                                            </>
                                          )}
                                        </List>
                                      </Collapse>
                                    </React.Fragment>
                                  ))}
                                </>
                              )}
                            </List>
                          </Collapse>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </List>
              </Collapse>
              {projectDetail?.plantDataAvailability?.showLossFlowDiagram && (
                <ListItem disablePadding sx={styles.nestedItem}>
                  <ListItemButton onClick={() => toggleMenu("Prescritive")}>
                    <ListItemIcon>
                      <StorageIcon />
                    </ListItemIcon>
                    <ListItemText
                                      primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                      primary="Prescriptive Model"
                    />
                    {openMenus.Prescritive ? (
                      <ExpandLessIcon sx={{ fontSize: "0.775rem" }} />
                    ) : (
                      <ChevronRightIcon sx={{ fontSize: "0.775rem" }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              <Collapse in={openMenus.Prescritive} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem disablePadding sx={styles.nestedItemLevel2}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedDetails("Fault Tree Diagram");
                        navigate(
                          `${
                            PageURL.INDIA_PRES_MODEL_Fault_Tree
                          }?${serachParams.toString()}`
                        );
                      }}
                      selected={selectedDetails === "Fault Tree Diagram"}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary="Fault Tree Diagram"
                      />
                    </ListItemButton>
                  </ListItem>

                  <ListItem disablePadding sx={styles.nestedItemLevel2}>
                    <ListItemButton
                      onClick={() => {
                        setSelectedDetails("Loss Flow Diagram");
                        navigate(
                          `${
                            PageURL.INDIA_PRES_MODEL_Loss_Flow
                          }?${serachParams.toString()}`
                        );
                      }}
                      selected={selectedDetails === "Loss Flow Diagram"}
                    >
                      <ListItemText
                                        primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                        primary="Loss Flow Diagram"
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              </Collapse>
            </List>
          </Collapse>

          {/* Admin Section */}
          {/* {
          user?.userLevel===1 &&
          <ListItem disablePadding>
            <ListItemButton onClick={() => navigate(PageURL.ADMIN_DASHBOARD)}>
              <ListItemIcon>
                <SettingsIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
              </ListItemIcon>
              <ListItemText
                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                primary="Admin"
              />
            </ListItemButton>
          </ListItem>} */}
        </List>
      </Box>

      {/* Logout button fixed at the bottom */}
      <Box sx={styles.logoutContainer}>
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => dispatch(userLogout())}>
              <ListItemIcon>
                <LogoutIcon fontSize="small" sx={{ fontSize: "0.875rem" }} />
              </ListItemIcon>
              <ListItemText
                                primaryTypographyProps={{
                  variant: "body2",
                  sx: { fontSize: "0.775rem" }, // Adjust text size (same as body2 default)
                }}
                primary="Logout"
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </>
  );

  // Menu button for mobile and tablet
  const menuButton = (
    <IconButton
      color="inherit"
      aria-label="open drawer"
      edge="start"
      onClick={handleDrawerToggle}
      sx={{
        ...styles.menuButton,
        top: isMobile ? "10px" : "13px",
        display: { xs: "block", md: open ? "none" : "block" },
        background: "#203864",
        color: "white",
      }}
    >
      <MenuIcon />
    </IconButton>
  );

  return (
    <ProjectContext.Provider
      value={{
        selectedCountry,
        selectedPartner,
        selectedProject,
        selectedDetails,
        setSelectedCountry,
        setSelectedPartner,
        setSelectedProject,
        setSelectedDetails,
      }}
    >
      {/* Menu button for mobile */}
      {menuButton}

      {/* Mobile drawer */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile
          }}
          sx={styles.drawer}
        >
          {drawer}
        </Drawer>
      )}

      {/* Desktop drawer */}
      {!isMobile && (
        <Drawer
          variant="persistent"
          open={open}
          sx={{
            ...styles.drawer,
            display: { xs: "none", md: "block" },
          }}
        >
          {drawer}
        </Drawer>
      )}

      {/* Toggle button for desktop */}
      {!isMobile && open && (
        <IconButton
          color="inherit"
          aria-label="toggle drawer"
          onClick={handleDrawerToggle}
          edge="start"
          sx={{
            position: "fixed",
            left: 230,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1201,
            // backgroundColor: "white",
            backgroundColor: "#203864",
            color: "white",
            border: "1px solid #e0e0e0",
            transition: "left 0.2s ease",
            "&:hover": {
              backgroundColor: "#203864",
              color: "#fff",
            },
          }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      )}

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: { md: open ? "230px" : 0 },
          transition: "margin 0.2s ease",
          width: { xs: "100%", md: `calc(100% - ${open ? 230 : 0}px)` },
        }}
      >
        {props?.children}
      </Box>
    </ProjectContext.Provider>
  );
}
